module.exports = __webpack_public_path__ + "assets/radio_icon.054f34eb.svg";